





























import { Vue, Component, Prop } from "vue-property-decorator";
import starActiveImg from "@/assets/star_active.png";
import starImg from "@/assets/star.png";
import { GoodsItem, GoodsImgInfo } from "@/interface/goods";
import posetr from "@/assets/check.jpg";
import { getGoodsDetail, star } from "@/http/goods";
@Component
export default class OldgoodsDetail extends Vue {
  dataInfo: GoodsItem | null = null;
  @Prop() id!: number;
  get goodsData() {
    return this.dataInfo || {};
  }
  get getStarImg() {
    return this.dataInfo?.like ? starActiveImg : starImg;
  }
  getImgUrl(item: GoodsImgInfo) {
    return window.StaticUrl + item.url;
  }
  get currentVideoUrl() {
    return this.dataInfo&&this.dataInfo.videoUrl ? this.dataInfo.videoUrl : null;
  }
  async star() {
    if (!this.dataInfo) return;
    const { id, like } = this.dataInfo;
    const res = await star({
      id,
      like: +!like
    });
    this.dataInfo = Object.assign({}, this.dataInfo, {
      likeCnt: like ? this.dataInfo.likeCnt - 1 : this.dataInfo.likeCnt + 1,
      like: !like
    });
  }

  async getGoodsDetail() {
    try {
      console.log(this.id);
      const res = await getGoodsDetail({ id: this.id });
      this.dataInfo = res;
    } catch (error) {
      console.log(error);
    }
  }
  async mounted() {
    await this.getGoodsDetail();
    (document.querySelectorAll(".old-goods-detail video") as any).forEach(
      (ele: any) => {
        ele.poster = posetr;
        ele.oncanplay = () => {
          ele.removeAttribute("poster");
          ele.controls = true;
          ele.preload = "auto";
          ele.style.height = "auto";
          console.log("can", ele);
        };
      }
    );
  }
}
